import { camelCase, isString } from 'lodash';
import IndexedDBLocalStorage from '../utils/indexDbStorage';
import { readExcelFile, readResponse, readSheetResponse } from '../utils/xlsxReader';
import { formatTableFun, getUserDefaultData, readExcelFileAndRecord, readExcelFileWithStylesAndRecord } from './common/mock';
import alasql from 'alasql';
import axios from 'axios';

const indexDbStorage = new IndexedDBLocalStorage();

const mockList = {
  '/api/customize-layout/fetch': async (req, res) => {
    if (req.body.property.dataSource) {
      try {
        if (req.body.property.dataSource.api && req.body.property.dataSource.api.url && req.body.property.dataSource.api.url.length > 0) {
          if (req.body.property.dataSource.api.url.startsWith('http') || !req.body.property.dataSource.api.mockLogic) {
            // fetch api
            // todo
          } else if (req.body.property.dataSource.api.mockLogic && req.body.property.dataSource.api.mockLogic.length > 0) {
            const mockFunc = new Function(`return ${req.body.property.dataSource.api.mockLogic}`).bind(this)();
            let data = null;
            const excelData = await indexDbStorage.getItem('excelData');
            if (excelData) {
              data = JSON.parse(excelData);
            } else {
              const config = await getUserDefaultData(req.queryStringParameters.email);
              data = await readExcelFileAndRecord(config.subpath, config.fileName);
            }
            const tableData = readResponse(data, 1);
            let titleList = tableData.Titles ?? [];
            const mockResult = mockFunc({ alasql, param: req.body, tables: tableData });
            return {
              status: 200,
              data: mockResult,
              titles: titleList,
            };
          }
        } else if (req.body.property.dataSource.mockData) {
          return {
            status: 200,
            data: isString(req.body.property.dataSource.mockData)
              ? JSON.parse(req.body.property.dataSource.mockData)
              : req.body.property.dataSource.mockData,
          };
        } else {
          return {
            status: 200,
            data: null,
          };
        }
      } catch (error) {
        console.error(error);
        return {
          status: 200,
          data: null,
        };
      }
    }
  },
  '/api/customize-layout/excel-table': async (req, res) => {
    let dataWithStyles = null;
    let tableType = '';
    let data = null;
    const excelData = await indexDbStorage.getItem('excelDataWithStyles');
    if (excelData) {
      dataWithStyles = JSON.parse(excelData);
    } else {
      const config = await getUserDefaultData(req.body.email);
      dataWithStyles = await readExcelFileWithStylesAndRecord(config.subpath, config.fileName);
    }
    Object.keys(dataWithStyles).forEach((key) => {
      if (key.includes(`${req.body.property.excelSheetName}`)) {
        data = dataWithStyles[key];
        tableType = key.split('-')[2];
      }
    });

    let tableColumns: any = [];
    let tableSource: any = [];
    let tableTitleLine = 1;
    if (data) {
      let tableF = formatTableFun(data, { tableType: tableType });
      tableColumns = tableF.tableColumns;
      tableSource = tableF.tableSource;
      tableTitleLine = tableF.titleRowCount + 1;
    }
    return {
      status: 200,
      data: { tableColumns, tableSource, tableTitleLine },
    };
  },
  '/api/customize-layout/prompt': async (req, res) => {
    let data = null;
    const excelData = await indexDbStorage.getItem('excelData');
    if (excelData) {
      data = JSON.parse(excelData);
    } else {
      const config = await getUserDefaultData(req.queryStringParameters.email);
      data = await readExcelFileAndRecord(config.subpath, config.fileName);
    }
    if (data['P']) {
      const resp = readSheetResponse(data['P'], 1);
      return {
        status: 200,
        data: resp,
      };
    } else {
      return {
        status: 200,
        data: [],
      };
    }
  },
  '/api/customize-layout/welcome': async (req, res) => {
    let data = null;
    const excelData = await indexDbStorage.getItem('excelData');
    if (excelData) {
      data = JSON.parse(excelData);
    } else {
      const config = await getUserDefaultData(req.queryStringParameters.email);
      data = await readExcelFileAndRecord(config.subpath, config.fileName);
    }
    let welcome = [];
    if (data['welcome']) {
      welcome = readSheetResponse(data['welcome'], 1);
    }
    return {
      status: 200,
      data: welcome,
    };
  },
  '/api/customize-layout/menus': async (req, res) => {
    let data = null;
    const excelData = await indexDbStorage.getItem('excelData');
    if (excelData) {
      data = JSON.parse(excelData);
    } else {
      const config = await getUserDefaultData(req.queryStringParameters.email);
      data = await readExcelFileAndRecord(config.subpath, config.fileName);
    }
    if (data['menus']) {
      const resp = readSheetResponse(data['menus'], 1);
      // 构建树结构
      const buildTree = (nodes) => {
        const nodeMap = new Map();

        // 创建节点映射
        nodes.forEach((node) => {
          nodeMap.set(node.key, node);
        });

        const tree = [];

        // 建立父子关系
        nodes.forEach((node) => {
          if (node.parentKey !== null && node.parentKey !== undefined) {
            const parentNode = nodeMap.get(node.parentKey);
            if (parentNode) {
              parentNode.children = parentNode.children || [];
              parentNode.children.push(node);
            }
          } else {
            tree.push(node);
          }
        });
        return tree;
      };

      return {
        status: 200,
        data: buildTree(
          resp.map((node) => {
            return { ...node, path: node.Action };
          })
        ),
      };
    } else {
      return {
        status: 200,
        data: [],
      };
    }
  },
  '/api/customize-layout/filter': async (req, res) => {
    let data = null;
    const excelData = await indexDbStorage.getItem('excelData');
    if (excelData) {
      data = JSON.parse(excelData);
    } else {
      const config = await getUserDefaultData(req.body.email);
      data = await readExcelFileAndRecord(config.subpath, config.fileName);
    }
    const filterData = {};
    if (req.body.filterItems) {
      Object.keys(data).forEach((key) => {
        if (
          req.body.filterItems.find((item) => {
            return item.filterName === key;
          })
        ) {
          filterData[key] = data[key];
        }
      });
    } else {
      Object.keys(data).forEach((key) => {
        if (key.startsWith(`${req.body.version}-F`)) {
          filterData[key] = data[key];
        }
      });
    }

    const resp = readResponse(filterData, 1);

    const filterList: any[] = [];

    for (const key in resp) {
      if (Object.prototype.hasOwnProperty.call(resp, key)) {
        const title = filterData[key][0][0].trim(); // A1 = 00
        const values = [];
        let defaultValue = [];
        let position = 'left';
        let variable = null;
        const actions = {};
        let width = null;
        let required = false;
        resp[key].forEach((element) => {
          values.push(element[title]);
          if (element['選択'] === 'x') {
            defaultValue.push(element[title]);
          }
          actions[element[title]] = element['Action'];
          if (element.width) {
            width = element.width;
          }
          if (element.position) {
            position = element.position;
          }
          if (element.variable) {
            variable = element.variable;
          }
          if (element.required) {
            required = !!element.required;
          }
        });
        let type = key.split('-').length === 3 ? key.split('-').pop() : 'multi';
        if (key.endsWith('gb')) {
          type = 'groupBtn';
        } else if (key.endsWith('s')) {
          type = 'single';
        } else if (key.endsWith('c')) {
          type = 'calendar';
        }

        filterList.push({
          title,
          type,
          values,
          defaultValue: defaultValue.length === 1 ? defaultValue[0] : defaultValue,
          actions,
          width,
          position,
          variable,
          required,
        });
      }
    }

    return {
      status: 200,
      data: filterList,
    };
  },
  '/api/get-calender': async () => {
    const data = await readExcelFile('/assets/calender/calender.xlsx');
    const response = readResponse(data, 2, false);
    const returnData: any = Object.keys(response).reduce((acc, cur) => {
      const data = response[cur];
      const camelCaseData = data.map((item) => {
        const innerData = Object.keys(item).reduce((a, c) => {
          const key = camelCase(c);
          a[key] = item[c];
          return a;
        }, {});
        return innerData;
      });

      acc[cur] = camelCaseData;
      return acc;
    }, {});
    return returnData.calender;
  },
  // toshiba
  // 'toshiba/v1/topData': async () => {
  //   const snapshot = '2025-08-01';
  //   const { data: target } = await axios.get(process.env.REACT_APP_DOMAIN + 'assets/mock-data/2025-07-01-data.json');
  //   const { data } = await axios.get(process.env.REACT_APP_DOMAIN + 'assets/mock-data/2025-08-01-data.json');
  //   const { data: plan } = await axios.get(process.env.REACT_APP_DOMAIN + 'assets/mock-data/mgmt_plan_monthly.json');
  //   return {
  //     data: data,
  //     plan: plan.filter((item) => snapshot === item.snapshot),
  //     target: target,
  //   };
  // },
  // 'toshiba/v1/ticketPage': async () => {
  //   const curSnapshot = '2025-08-01';
  //   const tarSnapshot = '2025-07-01';
  //   const lastYearSnapshot = '2024-08-01';
  //   const { data } = await axios.get(process.env.REACT_APP_DOMAIN + 'assets/mock-data/mgmt_monthly.json');
  //   const { data: lastYear } = await axios.get(process.env.REACT_APP_DOMAIN + 'assets/mock-data/mgmt_monthly_last_year.json');
  //   const { data: plan } = await axios.get(process.env.REACT_APP_DOMAIN + 'assets/mock-data/mgmt_plan_monthly.json');
  //   const currentData = data.filter((item) => curSnapshot === item.snapshot);
  //   const targetData = data.filter(item => tarSnapshot === item.snapshot);
  //   const planData = plan.filter((item) => curSnapshot === item.snapshot);
  //   const lastYearData = lastYear.filter((item) => lastYearSnapshot === item.snapshot);
  //   return {
  //     currentData,
  //     targetData,
  //     planData,
  //     lastYearData
  //   };
  // },
  // 'toshiba/v1/compareChart': async () => {
  //   const { data: targetData } = await axios.get(process.env.REACT_APP_DOMAIN + 'assets/mock-data/2025-07-01-data.json');
  //   const { data: currentData } = await axios.get(process.env.REACT_APP_DOMAIN + 'assets/mock-data/2025-08-01-data.json');
  //   return {
  //     currentData,
  //     targetData,
  //   };
  // },
};
export default mockList;
